import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  modal: {
    maxWidth: 580
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  },
  mainLabel: {
    marginTop: theme.spacing(2),
    fontSize: 32
  },
  fileName: {
    wordBreak: 'break-all'
  },
  input: {
    width: '100%'
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row-reverse',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2)
  },
  buttons: {
    padding: theme.spacing(0, 7)
  },
  clearButton: {
    marginRight: 'auto'
  }
});

export default makeStyles(styles);
